<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="list-wrap mg-b-15">
      <div class="list-heard d-flex mg-b-5 tx-white">
        <div class="c-5">
          {{ $t("mall.联系方式") }}
        </div>
        <div class="c-8">
          {{ $t("mall.留言内容") }}
        </div>
        <div class="c-7">
          {{ $t("mall.供应商回复") }}
        </div>
        <div class="c-2 tx-center">
          {{ $t("mall.未读消息") }}
        </div>
        <div class="c-2">
          {{ $t("mall.操作") }}
        </div>
      </div>
      <div
        v-for="item in items"
        :key="item.id"
        class="card bd-gray-400 pd-5 tx-12 mg-b-10"
      >
        <div class="d-flex flex-row align-items-center justify-content-start">
          <div class="c-5">
            <div>
              {{ $t("mall.客户") }}:
              <span class="tx-white">{{ item.distributor }}</span>
            </div>
            <div v-if="item.distributorMobile">
              <i class="mg-r-5 iconfont icon-mobile"></i>
              <span class="tx-white">{{ item.distributorMobile }}</span>
            </div>
            <div v-if="item.distributorQQ">
              <svg class="iconfont icons qq-color mg-r-5">
                <use xlink:href="#icon-qq-color"></use>
              </svg>
              <span class="tx-white">{{ item.distributorQQ }}</span>
            </div>
          </div>

          <div class="c-8">
            <div class="c-24 tx-white tx-ellipsis1 mg-b-10">
              {{ item.lastConsultContent }}
            </div>
            <div class="d-flex align-items-center">
              <div class="img-list mg-r-25">
                <div
                  v-for="(img, imgIndex) in item.lastConsultImageUrlJson"
                  :key="img"
                  class="img-wrap"
                  v-lazy:background-image="img"
                  @click="preview(item.lastConsultImageUrlJson, imgIndex)"
                ></div>
                <div
                  v-if="
                    !item.lastConsultImageUrlJson ||
                    !item.lastConsultImageUrlJson.length
                  "
                >
                  {{ $t("mall.没有图") }}
                </div>
              </div>
              <div>
                <i class="iconfont icon-wait tx-14 mg-r-5"></i>
                <span class="tx-white">{{ item.lastConsultTimeCreated }}</span>
              </div>
            </div>
          </div>

          <div class="c-7">
            <template v-if="item.lastReplyTimeCreated">
              <div class="c-24 tx-white tx-ellipsis1 mg-b-10">
                {{ item.lastReplyContent }}
              </div>
              <div class="d-flex align-items-center">
                <div class="img-list mg-r-25">
                  <div
                    v-for="(img, imgIndex) in item.lastReplyImageUrlJson"
                    :key="img"
                    class="img-wrap"
                    v-lazy:background-image="img"
                    @click="preview(item.lastReplyImageUrlJson, imgIndex)"
                  ></div>
                  <div
                    v-if="
                      !item.lastReplyImageUrlJson ||
                      !item.lastReplyImageUrlJson.length
                    "
                  >
                    {{ $t("mall.没有图") }}
                  </div>
                </div>
                <div>
                  <i class="iconfont icon-wait tx-14 mg-r-5"></i>
                  <span class="tx-white">{{ item.lastReplyTimeCreated }}</span>
                </div>
              </div>
            </template>
          </div>

          <div class="c-2 tx-center">
            {{ item.unReadCnt }}
          </div>

          <div class="c-2">
            <div v-if="isSysRights('Consult.getBySupplier')">
              <a
                class="tx-info"
                href="javascript:;"
                @click="openModalMessage(item)"
                >{{ $t("mall.详情与回复") }}</a
              >
            </div>
            <div>
              <router-link
                class="tx-info"
                :to="{
                  path: '/sale-order',
                  query: { id: item.relationshipId },
                }"
                target="_blank"
                >{{ $t("mall.创建销售订单") }}</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="(!items || !items.length) && !first_loading"
        class="col-12 none-product"
      >
        <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的留言咨询") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["items", "first_loading"],
  methods: {
    preview(item, index) {
      this.$parent.loading = true;
      let imgArr = [];
      item.forEach((e) => {
        imgArr.push({
          img: e,
          text: e,
        });
      });
      this.$store.commit("setImgItem", imgArr);
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        viewer.view(index);
        this.$parent.loading = false;
      }, 500);
    },
    openModalMessage(distributorId) {
      this.$emit("openModalMessage", distributorId);
    },
  },
};
</script>

<style lang="less" scoped>
.img-list {
  display: flex;
  flex-wrap: wrap;
  max-width: 270px;
  .img-wrap {
    width: 40px;
    height: 40px;
    background-size: cover;
    border: 1px #ddd solid;
    margin-right: 5px;
    margin-bottom: 5px;
    cursor: pointer;
  }
}
</style>
